module.exports = __webpack_public_path__ + "static/img/wksq_2.8b318b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/wksq_2.jpg
// module id = 9kzK
// module chunks = 15